import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
import DeviceInfoList from "./DeviceInfoList";
export default {
  components: {
    DeviceInfoList: DeviceInfoList
  },
  data: function data() {
    return {
      tabKeys: "",
      categoryList: [{
        id: '12',
        name: '检测仪表'
      }, {
        id: '11',
        name: '运维设备'
      }, {
        id: '91',
        name: '应急物资'
      }]
    };
  },
  watch: {
    '$route.path': function $routePath() {
      this.categoryList = [{
        id: '12',
        name: '检测仪表'
      }, {
        id: '11',
        name: '运维设备'
      }, {
        id: '91',
        name: '应急物资'
      }];
      var categoryIds = this.$route.path.split('/').pop().split(',');
      this.categoryList = this.categoryList.filter(function (item) {
        return categoryIds.includes(item.id);
      });
      this.tabKeys = this.categoryList[0].id;
    }
  },
  created: function created() {
    var categoryIds = this.$route.path.split('/').pop().split(',');
    this.categoryList = this.categoryList.filter(function (item) {
      return categoryIds.includes(item.id);
    });
    this.tabKeys = this.categoryList[0].id;
  },
  methods: {}
};